
import { Record, Union } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Types.js";
import { record_type, bool_type, lambda_type, unit_type, union_type, list_type, class_type, option_type, anonRecord_type, string_type } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";
import { Helper_receiverTypeNameTranslation, ReceiverTypeName, Receiver_$reflection } from "../../Shared/User.js";
import { FormState__getValidation, SetId as SetId_1, FormState__startLoading, FormState__setValidationResponse_5219762A, RequestedValue$1, FormState_get_empty, RequestedValue$1_$reflection, FormState_$reflection, ClientApiResponse$1_$reflection } from "../../Shared/Shared.js";
import { ImageUpload, DnDFormImage, DnDFormImage_$reflection } from "../../Widgets/Image/ImageUploadDnD.js";
import { FileUploadResponse_$reflection } from "../../Shared/File.js";
import { DataTransfer_AssignSetDto, DataTransfer_DetailSet_$reflection, DataTransfer_AssignSetDto_$reflection } from "../../Shared/Set.js";
import { tryFind, sortBy, toArray, map as map_1, append, max, filter, tryPick, sumBy, choose, ofArray, singleton, empty } from "../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { Cmd_ofEffect, Cmd_none, Cmd_batch } from "../../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { Cmd_OfPromise_either } from "../../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "../../fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { promise } from "../../fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";
import { fetchWithDecoder, addPrefix } from "../../CommunicationV2.js";
import { Types_RequestProperties } from "../../fable_modules/Fable.Fetch.2.1.0/Fetch.fs.js";
import { Reader_$ctor_Z3F6BC7B1, Reader__Read_24524716 } from "../../fable_modules/Fable.Remoting.MsgPack.1.25.0/Read.fs.js";
import { ValidationOnGetRequest } from "../../ErrorHandling.js";
import { join, concat } from "../../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { unwrap, map } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import { toISOString } from "../../Common.js";
import { Cmd_successToast, Cmd_errorToast } from "../../Components/Toast.js";
import { assignCmd } from "../../Requests/Set.js";
import { parse } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Guid.js";
import { uploadImage } from "../../Requests/Files.js";
import { safeHash, equals, createObj, comparePrimitives } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { createElement } from "react";
import React from "react";
import { useTranslation } from "react-i18next";
import { reactApi, reactElement } from "../../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { empty as empty_1, singleton as singleton_1, append as append_1, delay, toList } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { SetInfo } from "../../Widgets/SetInfoWidget.js";
import { GroupedSelect } from "../../Components/Select.js";
import { List_groupBy } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Seq2.js";
import { TextArea } from "../../Components/TextArea.js";
import { DatePicker } from "../../Components/DatePicker.js";
import { TextValue } from "../../Components/Text.js";
import { ErrorAlert } from "../../Components/Alert.js";
import { React_useElmish_Z6C327F2E } from "../../fable_modules/Feliz.UseElmish.2.5.0/UseElmish.fs.js";
import { ProgramModule_mkProgram } from "../../fable_modules/Fable.Elmish.5.0.2/program.fs.js";
import { Dialog } from "../../Components/Dialog.js";
import { Skeleton } from "../../Components/Skeleton.js";
import { TextButton } from "../../Components/Button.js";

class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["SelectReceiver", "SetComment", "SelectReturnDate", "AssignedResponse", "OnAssign", "ReceiversFetched", "FetchError", "SetSelectedSenderFiles", "SenderImageUploaded"];
    }
}

function Msg_$reflection() {
    return union_type("Sets.Dialog.ReceiverToReceiverAssignDialog.Msg", [], Msg, () => [[["Item", option_type(anonRecord_type(["label", string_type], ["value", Receiver_$reflection()]))]], [["Item", string_type]], [["Item", option_type(class_type("System.DateTime"))]], [["Item", ClientApiResponse$1_$reflection(string_type)]], [], [["Item", list_type(Receiver_$reflection())]], [["Item", class_type("System.Exception")]], [["Item", list_type(DnDFormImage_$reflection())]], [["Item", FileUploadResponse_$reflection()]]]);
}

class State extends Record {
    constructor(Dto, Set$, SelectedReturnDate, FormState, SuccessCallback, OnClose, Receivers, SenderImageFiles, ImageUploading) {
        super();
        this.Dto = Dto;
        this.Set = Set$;
        this.SelectedReturnDate = SelectedReturnDate;
        this.FormState = FormState;
        this.SuccessCallback = SuccessCallback;
        this.OnClose = OnClose;
        this.Receivers = Receivers;
        this.SenderImageFiles = SenderImageFiles;
        this.ImageUploading = ImageUploading;
    }
}

function State_$reflection() {
    return record_type("Sets.Dialog.ReceiverToReceiverAssignDialog.State", [], State, () => [["Dto", DataTransfer_AssignSetDto_$reflection()], ["Set", DataTransfer_DetailSet_$reflection()], ["SelectedReturnDate", option_type(class_type("System.DateTime"))], ["FormState", FormState_$reflection()], ["SuccessCallback", lambda_type(unit_type, unit_type)], ["OnClose", lambda_type(unit_type, unit_type)], ["Receivers", RequestedValue$1_$reflection(list_type(Receiver_$reflection()))], ["SenderImageFiles", list_type(DnDFormImage_$reflection())], ["ImageUploading", bool_type]]);
}

const maxSenderImages = 5;

function init(set$, successCallback, onClose) {
    let businessUnitId;
    return [new State(new DataTransfer_AssignSetDto("", "", undefined, undefined, empty()), set$, undefined, FormState_get_empty(), successCallback, onClose, new RequestedValue$1(0, []), empty(), false), Cmd_batch(singleton((businessUnitId = set$.BusinessUnitId, Cmd_OfPromise_either((url) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
        let url_2;
        return ((url_2 = addPrefix(url), (refreshOn) => fetchWithDecoder(url_2, singleton(new Types_RequestProperties(0, ["GET"])), "application/json", (response) => {
            const pr = response.arrayBuffer();
            return pr.then((blob) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob)), list_type(Receiver_$reflection())));
        }, refreshOn)))(true).then((_arg) => {
            const result_1 = _arg;
            return (result_1.tag === 1) ? (Promise.resolve((() => {
                throw new ValidationOnGetRequest(result_1.fields[0]);
            })())) : (Promise.resolve(result_1.fields[0]));
        });
    })), concat("/api/receivers/active", ...((businessUnitId == null) ? "?businessUnitId=" : concat("?businessUnitId=", ...businessUnitId))), (Item) => (new Msg(5, [Item])), (Item_1) => (new Msg(6, [Item_1]))))))];
}

function update(msg, state) {
    let bind$0040_1, bind$0040_2, bind$0040_3, file_1, bind$0040;
    switch (msg.tag) {
        case 1:
            return [new State((bind$0040_1 = state.Dto, new DataTransfer_AssignSetDto(bind$0040_1.AffectedReceiverId, msg.fields[0], bind$0040_1.PlannedReturnDate, bind$0040_1.SignatureUrl, bind$0040_1.SenderImageUrls)), state.Set, state.SelectedReturnDate, state.FormState, state.SuccessCallback, state.OnClose, state.Receivers, state.SenderImageFiles, state.ImageUploading), Cmd_none()];
        case 2: {
            const value_1 = msg.fields[0];
            return [new State((bind$0040_2 = state.Dto, new DataTransfer_AssignSetDto(bind$0040_2.AffectedReceiverId, bind$0040_2.Comment, map(toISOString, value_1), bind$0040_2.SignatureUrl, bind$0040_2.SenderImageUrls)), state.Set, value_1, state.FormState, state.SuccessCallback, state.OnClose, state.Receivers, state.SenderImageFiles, state.ImageUploading), Cmd_none()];
        }
        case 3: {
            const response = msg.fields[0];
            if (response.tag === 1) {
                return [new State(state.Dto, state.Set, state.SelectedReturnDate, FormState__setValidationResponse_5219762A(state.FormState, response.fields[0]), state.SuccessCallback, state.OnClose, state.Receivers, state.SenderImageFiles, state.ImageUploading), Cmd_errorToast("validation.toast")];
            }
            else {
                return [new State(state.Dto, state.Set, state.SelectedReturnDate, FormState_get_empty(), state.SuccessCallback, state.OnClose, state.Receivers, state.SenderImageFiles, state.ImageUploading), Cmd_batch(ofArray([Cmd_ofEffect((_arg) => {
                    state.SuccessCallback();
                }), Cmd_successToast("general.saved_successfully"), Cmd_ofEffect((_arg_1) => {
                    state.OnClose();
                })]))];
            }
        }
        case 4:
            if (state.Dto.AffectedReceiverId !== "") {
                const senderImageUrls = choose((f) => {
                    if (f.tag === 1) {
                        return f.fields[0].ImageUrl;
                    }
                    else {
                        return undefined;
                    }
                }, state.SenderImageFiles);
                return [new State(state.Dto, state.Set, state.SelectedReturnDate, FormState__startLoading(state.FormState), state.SuccessCallback, state.OnClose, state.Receivers, state.SenderImageFiles, state.ImageUploading), assignCmd(new SetId_1(parse(state.Set.Id)), (bind$0040_3 = state.Dto, new DataTransfer_AssignSetDto(bind$0040_3.AffectedReceiverId, bind$0040_3.Comment, bind$0040_3.PlannedReturnDate, bind$0040_3.SignatureUrl, senderImageUrls)), (Item_1) => (new Msg(3, [Item_1])), (Item_2) => (new Msg(6, [Item_2])))];
            }
            else {
                return [state, Cmd_none()];
            }
        case 5:
            return [new State(state.Dto, state.Set, state.SelectedReturnDate, state.FormState, state.SuccessCallback, state.OnClose, new RequestedValue$1(1, [msg.fields[0]]), state.SenderImageFiles, state.ImageUploading), Cmd_none()];
        case 6:
            return [new State(state.Dto, state.Set, state.SelectedReturnDate, FormState_get_empty(), state.SuccessCallback, state.OnClose, state.Receivers, state.SenderImageFiles, false), Cmd_none()];
        case 7: {
            const newFiles = msg.fields[0];
            const alreadyUploadedCount = sumBy((f_1) => {
                if (f_1.tag === 1) {
                    return 1;
                }
                else {
                    return 0;
                }
            }, state.SenderImageFiles, {
                GetZero: () => 0,
                Add: (x, y) => ((x + y) | 0),
            }) | 0;
            const pickedFile = tryPick((f_2) => {
                if (f_2.tag === 0) {
                    return f_2.fields[0].File;
                }
                else {
                    return undefined;
                }
            }, newFiles);
            let matchResult, file_2;
            if (pickedFile != null) {
                if ((file_1 = pickedFile, alreadyUploadedCount < maxSenderImages)) {
                    matchResult = 0;
                    file_2 = pickedFile;
                }
                else {
                    matchResult = 1;
                }
            }
            else {
                matchResult = 1;
            }
            switch (matchResult) {
                case 0: {
                    const formData = new FormData();
                    formData.append(file_2.name, file_2);
                    return [new State(state.Dto, state.Set, state.SelectedReturnDate, state.FormState, state.SuccessCallback, state.OnClose, state.Receivers, newFiles, true), uploadImage((Item_3) => (new Msg(8, [Item_3])), (Item_4) => (new Msg(6, [Item_4])), formData)];
                }
                default:
                    return [new State(state.Dto, state.Set, state.SelectedReturnDate, state.FormState, state.SuccessCallback, state.OnClose, state.Receivers, newFiles, state.ImageUploading), Cmd_none()];
            }
        }
        case 8: {
            const response_2 = msg.fields[0];
            switch (response_2.tag) {
                case 0:
                    return [new State(state.Dto, state.Set, state.SelectedReturnDate, state.FormState, state.SuccessCallback, state.OnClose, state.Receivers, filter((f_5) => {
                        if (f_5.tag === 1) {
                            return true;
                        }
                        else {
                            return false;
                        }
                    }, state.SenderImageFiles), false), Cmd_errorToast("general.file_too_large")];
                case 2:
                    return [new State(state.Dto, state.Set, state.SelectedReturnDate, state.FormState, state.SuccessCallback, state.OnClose, state.Receivers, filter((f_6) => {
                        if (f_6.tag === 1) {
                            return true;
                        }
                        else {
                            return false;
                        }
                    }, state.SenderImageFiles), false), Cmd_errorToast("general.a_error_occured")];
                default: {
                    const nextPosition = (1 + max(append(singleton(0), choose((f_3) => {
                        if (f_3.tag === 1) {
                            return f_3.fields[0].Position;
                        }
                        else {
                            return undefined;
                        }
                    }, state.SenderImageFiles)), {
                        Compare: (x_1, y_1) => (comparePrimitives(x_1, y_1) | 0),
                    })) | 0;
                    return [new State(state.Dto, state.Set, state.SelectedReturnDate, state.FormState, state.SuccessCallback, state.OnClose, state.Receivers, append(choose((f_4) => {
                        if (f_4.tag === 1) {
                            return f_4;
                        }
                        else {
                            return undefined;
                        }
                    }, state.SenderImageFiles), singleton(new DnDFormImage(1, [{
                        ImageUrl: response_2.fields[0].ImageUrl,
                        Position: nextPosition,
                    }]))), false), Cmd_none()];
                }
            }
        }
        default: {
            const value = msg.fields[0];
            if (value == null) {
                return [state, Cmd_none()];
            }
            else {
                return [new State((bind$0040 = state.Dto, new DataTransfer_AssignSetDto(value.value.Id, bind$0040.Comment, bind$0040.PlannedReturnDate, bind$0040.SignatureUrl, bind$0040.SenderImageUrls)), state.Set, state.SelectedReturnDate, state.FormState, state.SuccessCallback, state.OnClose, state.Receivers, state.SenderImageFiles, state.ImageUploading), Cmd_none()];
            }
        }
    }
}

function DialogBody(props) {
    let elems_2;
    const t = useTranslation()[0];
    return reactElement("div", createObj(ofArray([["className", join(" ", ["grid", "gap-4"])], (elems_2 = toList(delay(() => {
        let elems;
        return append_1(singleton_1(reactElement("div", createObj(ofArray([["className", join(" ", [])], (elems = [createElement(SetInfo, {
            DisplayReservationAlert: true,
            SetId: new SetId_1(parse(props.Set.Id)),
        })], ["children", reactApi.Children.toArray(Array.from(elems))])])))), delay(() => append_1(singleton_1(createElement(GroupedSelect, (($value) => { $value.key = $value.Key; return $value; })({
            ComponentState: props.ComponentState,
            IsClearable: false,
            Key: "assign-tool-select-user",
            NoOptionsMessage: "select.employee_no_options",
            OnChange: props.SetSelectedReceiver,
            Options: map_1((tupledArg) => {
                const receiverType = tupledArg[0];
                const receivers_1 = toArray(sortBy((receiver_2) => receiver_2.label.toLowerCase(), map_1((receiver_1) => {
                    const matchValue = receiver_1.LocationName;
                    if (matchValue != null) {
                        const locationName = matchValue;
                        if (equals(receiverType, new ReceiverTypeName(4, []))) {
                            return {
                                label: concat(locationName, " - ", ...receiver_1.Name),
                                value: receiver_1,
                            };
                        }
                        else {
                            return {
                                label: concat(receiver_1.Name, " - ", ...locationName),
                                value: receiver_1,
                            };
                        }
                    }
                    else {
                        return {
                            label: receiver_1.Name,
                            value: receiver_1,
                        };
                    }
                }, tupledArg[1]), {
                    Compare: (x_1, y_1) => (comparePrimitives(x_1, y_1) | 0),
                }));
                return {
                    label: Helper_receiverTypeNameTranslation(t, receiverType),
                    options: receivers_1,
                };
            }, List_groupBy((receiver) => receiver.ReceiverType, filter((r) => (r.Id !== props.AssignedReceiverId), props.Receivers), {
                Equals: equals,
                GetHashCode: (x) => (safeHash(x) | 0),
            })),
            PlaceholderKey: "select.employee_placeholder",
            Value: unwrap(props.SelectedReceiver),
        }))), delay(() => append_1(singleton_1(createElement(TextArea, {
            ComponentState: props.ComponentState,
            Label: t("general.comment"),
            OnChange: props.SetComment,
            TestId: "assign-tool-comment",
            Value: props.Comment,
        })), delay(() => append_1(singleton_1(createElement(DatePicker, {
            ComponentState: props.ComponentState,
            IsClearable: true,
            Label: t("tool.dialog_planned_return_date"),
            OnChange: props.SetReturnDate,
            TestId: "assign-tool-from-user-to-user-planned-returned-date-test-id",
            ValidationMessage: unwrap(FormState__getValidation(props.FormState, t, "plannedReturnDate")),
            Value: unwrap(props.ReturnDate),
        })), delay(() => {
            let elems_1;
            return append_1(singleton_1(reactElement("div", createObj(ofArray([["className", join(" ", ["grid", "gap-2"])], (elems_1 = [createElement(TextValue, {
                FontWeight: "bold",
                TestId: "",
                Text: t("assignment_notification.sender_images"),
            }), createElement(ImageUpload, {
                ComponentState: props.ImageUploading ? "disabled" : props.ComponentState,
                SelectedFiles: props.SenderImageFiles,
                SetSelectedFile: props.SetSelectedSenderFiles,
            })], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))), delay(() => {
                const matchValue_1 = FormState__getValidation(props.FormState, t, "global");
                if (matchValue_1 == null) {
                    return empty_1();
                }
                else {
                    return singleton_1(createElement(ErrorAlert, {
                        Label: matchValue_1,
                    }));
                }
            }));
        }))))))));
    })), ["children", reactApi.Children.toArray(Array.from(elems_2))])])));
}

export function OpenAssignFromReceiverToReceiverDialog(props) {
    let Title;
    const t = useTranslation()[0];
    const patternInput_1 = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram(() => init(props.Set, props.OnClose, props.SuccessCallback), update, (_arg_1, _arg_1_1) => {
    }), undefined, [props.IsOpen]);
    const state_1 = patternInput_1[0];
    const dispatch = patternInput_1[1];
    return createElement(Dialog, (Title = t("tool.assign_now_to_other_user"), {
        Body: toList(delay(() => {
            const matchValue = state_1.Receivers;
            const matchValue_1 = props.Set.LocationInformation.AssignedReceiverId;
            let matchResult, assignedReceiverId, receivers;
            if (matchValue.tag === 0) {
                if (matchValue_1 == null) {
                    matchResult = 1;
                }
                else {
                    matchResult = 1;
                }
            }
            else if (matchValue_1 == null) {
                matchResult = 1;
            }
            else {
                matchResult = 0;
                assignedReceiverId = matchValue_1;
                receivers = matchValue.fields[0];
            }
            switch (matchResult) {
                case 0:
                    return singleton_1(createElement(DialogBody, {
                        AssignedReceiverId: assignedReceiverId,
                        Comment: state_1.Dto.Comment,
                        ComponentState: state_1.FormState.IsLoading ? "disabled" : "enabled",
                        FormState: state_1.FormState,
                        ImageUploading: state_1.ImageUploading,
                        Receivers: receivers,
                        ReturnDate: unwrap(state_1.SelectedReturnDate),
                        SelectedReceiver: unwrap(map((receiver_1) => ({
                            label: receiver_1.Name,
                            value: receiver_1,
                        }), tryFind((receiver) => (receiver.Id === state_1.Dto.AffectedReceiverId), receivers))),
                        SenderImageFiles: state_1.SenderImageFiles,
                        Set: props.Set,
                        SetComment: (value) => {
                            dispatch(new Msg(1, [value]));
                        },
                        SetReturnDate: (value_1) => {
                            dispatch(new Msg(2, [value_1]));
                        },
                        SetSelectedReceiver: (value_2) => {
                            dispatch(new Msg(0, [value_2]));
                        },
                        SetSelectedSenderFiles: (files) => {
                            dispatch(new Msg(7, [files]));
                        },
                    }));
                default:
                    return singleton_1(createElement(Skeleton, {
                        Variant: "normal",
                    }));
            }
        })),
        Controls: ofArray([createElement(TextButton, {
            ComponentState: "enabled",
            Label: t("general.cancel"),
            OnClick: props.OnClose,
            TestId: "close-reservation-dialog-test-id",
            Variant: "blueButton",
        }), createElement(TextButton, {
            ComponentState: ((state_1.FormState.IsLoading ? true : state_1.ImageUploading) ? true : (state_1.Dto.AffectedReceiverId === "")) ? "disabled" : "enabled",
            Label: t("general.save"),
            OnClick: () => {
                dispatch(new Msg(4, []));
            },
            TestId: "save-assign-dialog-test-id",
            Variant: "blueButton",
        })]),
        IsOpen: props.IsOpen,
        OnClose: props.OnClose,
        Title: Title,
    }));
}

